<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span class="px-0">大會活動</span><span>/</span
            ><a href="javascript:history.back()">{{ EventName }}</a
            ><span>/</span>編輯推廣產品
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>編輯推廣產品</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="EditPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">產品名稱</p>
              <p>
                {{ ProductName }}
              </p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">分類 <span class="red">*</span></p>
              <div class="form-row">
                <div class="form-group col-md-2">
                  <select
                    class="form-control text-dark"
                    v-model="PromotionProDetail.mCatID"
                    required
                  >
                    <option value="">-- 請選擇 --</option>
                    <option v-for="item in EventCatList" :value="item.mCatID">
                      {{ item.mCatName }}
                    </option>
                  </select>
                </div>
              </div>
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <div v-if="inputDescHidden == 0">
                <div v-if="inputDescName">
                  <p class="formTitle">
                    {{ inputDescName }}
                    <span class="red" v-if="inputDescRequired == 0">*</span>
                  </p>
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="20"
                      v-model="PromotionProDetail.reg_Desc"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1">{{ inputDescNotes }}</div>
                  <div v-if="einputDescNotes">
                    <div class="langTip mt-2">
                      <input
                        type="text"
                        name="Desc"
                        class="maxText textStyle"
                        :required="inputDescRequired == 0"
                        maxlength="50"
                        v-model="PromotionProDetail.ereg_Desc"
                      />
                      <span>英 </span>
                    </div>
                    <div class="blueBG mt-1">{{ einputDescNotes }}</div>
                  </div>

                  <p class="my-3">&nbsp;</p>
                </div>

                <div v-else>
                  <p class="formTitle">
                    {{ inputDescName }}
                    <span class="red" v-if="inputDescRequired == 0">*</span>
                  </p>
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="20"
                      v-model="PromotionProDetail.reg_Desc"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1">{{ inputDescNotes }}</div>

                  <p class="my-3">&nbsp;</p>
                </div>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <div v-if="inputDescName2">
                  <p class="formTitle">
                    {{ inputDescName2 }}
                    <span class="red" v-if="inputDescRequired2 == 0">*</span>
                  </p>
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="20"
                      v-model="PromotionProDetail.reg_Desc2"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1">{{ inputDescNotes2 }}</div>
                  <div v-if="einputDescNotes2">
                    <div class="langTip mt-2">
                      <input
                        type="text"
                        name="Desc2"
                        class="maxText textStyle"
                        :required="inputDescRequired2 == 0"
                        maxlength="50"
                        v-model="PromotionProDetail.ereg_Desc2"
                      />
                      <span>英 </span>
                    </div>
                    <div class="blueBG mt-1">{{ einputDescNotes2 }}</div>
                  </div>
                  <p class="my-3">&nbsp;</p>
                </div>

                <div v-else>
                  <p class="formTitle">
                    {{ inputDescName2 }}
                    <span class="red" v-if="inputDescRequired2 == 0">*</span>
                  </p>
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="20"
                      v-model="PromotionProDetail.reg_Desc2"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1">{{ inputDescNotes2 }}</div>

                  <p class="my-3">&nbsp;</p>
                </div>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  上市時間
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle"
                    :required="inputOnlineDateRequired == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  市價(NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle"
                    :required="inputPriceRequired == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  展場限定價(NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle"
                    :required="inputDiscountPriceRe == 0"
                    maxlength="20"
                    v-model="PromotionProDetail.reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="toPromotionList">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "編輯推廣產品 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      ProductID: "",
      PromotionProDetail: {},
      reg_Desc: "",
      reg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventDetail: {},
      EventCatList: [],
      mCatID: "",
      eventId: "",
      RegId: "",
      ProductName: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      einputDescName: "",
      einputDescName2: "",
      einputDescNotes: "",
      einputDescNotes2: "",

      inputDescName2: "",
      inputDescNotes: "",
      inputDescNotes2: "",
      inputDescRequired: "",
      inputDescRequired2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
      inputDescHidden2: "",
    };
  },

  watch: {},

  methods: {
    EditPromotionPro() {
      const vm = this;
      const url = `/apiExhibitors/MarketingEventRegisterUpdate/${vm.RegNo}/${vm.RegId}`;

      const info = {
        proNo: vm.PromotionProDetail.proNo,
        mCatID: vm.PromotionProDetail.mCatID,
        reg_Desc: vm.PromotionProDetail.reg_Desc,
        reg_Desc2: vm.PromotionProDetail.reg_Desc2,
        ereg_Desc2: vm.PromotionProDetail.ereg_Desc2,
        ereg_Desc: vm.PromotionProDetail.ereg_Desc,

        reg_LaunchDate: vm.PromotionProDetail.reg_LaunchDate,
        reg_Price: vm.PromotionProDetail.reg_Price,
        reg_DiscountPrice: vm.PromotionProDetail.reg_DiscountPrice,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          alert("您已成功修改產品說明！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 500) {
          alert("系統忙碌，請稍後再試！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 252) {
          // console.log('CSRF驗證失敗')
        } else if (response.data.Code == 253) {
          alert("報名序號錯誤或不存在！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 254) {
          alert("參展商報名表序號錯誤或不存在！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
    },

    toPromotionList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.eventId = currentUrl.split("eventId=")[1].split("&")[0];
    vm.RegId = currentUrl.split("regId=")[1];

    let url2 = `/apiExhibitors/MarketingEventRegister/${vm.RegNo}/${vm.RegId}`;
    axios.get(url2).then(function (response) {
      // console.log(response.data)
      vm.PromotionProDetail = response.data.Data[0];
      // console.log(vm.PromotionProDetail)
      let GetProNo = vm.PromotionProDetail.proNo;

      let url = `/apiExhibitors/Product/${vm.RegNo}/${GetProNo}`;
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductName = response.data.Data.ProName;
      });
    });

    //取得線上展總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.EventDetail = response.data.Data;
        vm.EventCatList = response.data.Data.category;

        // 欄位顯示判定

        vm.inputDescHidden = response.data.Data.inputDescHidden;
        vm.inputDescHidden2 = response.data.Data.inputDescHidden2;

        vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden;
        vm.inputPriceHidden = response.data.Data.inputPriceHidden;
        vm.inputDiscountPriceHidden =
          response.data.Data.inputDiscountPriceHidden;

        vm.inputDescName = response.data.Data.inputDescName;
        vm.inputDescName2 = response.data.Data.inputDescName2;
        vm.inputDescNotes = response.data.Data.inputDescNotes;
        vm.inputDescNotes2 = response.data.Data.inputDescNotes2;
        vm.einputDescNotes = response.data.Data.einputDescNotes;
        vm.einputDescNotes2 = response.data.Data.einputDescNotes2;
        vm.einputDescName = response.data.Data.einputDescName;
        vm.einputDescName2 = response.data.Data.einputDescName2;
        vm.EventName = response.data.Data.eventName;

        //必填

        vm.inputDescRequired = response.data.Data.inputDescRequired;
        vm.inputDescRequired2 = response.data.Data.inputDescRequired2;
        vm.inputOnlineDateRequired = response.data.Data.inputOnlineDateRequired;
        vm.inputPriceRequired = response.data.Data.inputPriceRequired;
        vm.inputDiscountPriceRequired =
          response.data.Data.inputDiscountPriceRequired;

        if (vm.inputDescRequired == 0) {
          $(".inputDescRe")[0].setAttribute("required", "true");
          $(".inputDescReCn")[0].setAttribute("required", "true");
        }
        if (vm.inputDescRequired2 == 0) {
          $(".inputDescRe2")[0].setAttribute("required", "true");
          $(".inputDescRe2Cn")[0].setAttribute("required", "true");
        }
        if (vm.inputOnlineDateRequired == 0) {
          $(".inputOnlineDateRe")[0].setAttribute("required", "true");
        }
        if (vm.inputPriceRequired == 0) {
          $(".inputPriceRe")[0].setAttribute("required", "true");
        }
        if (vm.inputDiscountPriceRequired == 0) {
          $(".inputDiscountPriceRe")[0].setAttribute("required", "true");
        }

        // 開啟時間判定
        let OpenRegiterDate = response.data.Data.backEndStartDate;
        let CloseRegiterDate = response.data.Data.backEndEndDate;
        let Nowdate = Date.parse(new Date()).valueOf();

        // console.log(OpenRegiterDate)
        // console.log(CloseRegiterDate)
        // console.log(Nowdate)

        if (Nowdate < OpenRegiterDate) {
          alert("活動尚未開放");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (Nowdate > CloseRegiterDate) {
          alert("活動尚未開放");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
  },
};
</script>

<style lang="scss"></style>
